import React from "react";
import { Icon, NamedProperty, Stack } from "sprint-common-web";

import { AssetType } from "../../../../common/types/AssetType";
import { LanguageReference } from "../../../../common/types/references/LanguageReference";
import { OrderAssetAvailability } from "../../types/OrderAssetAvailability";
import { OrderAssetStorageType } from "../../types/OrderAssetStorageType";
import { OrderResolutionDimensions } from "../../types/OrderResolutionDimensions";
import { getAssetAvailabilityIconName } from "../../utils/getAssetAvailabilityIconName";
import { getAssetAvailabilityColor } from "../../utils/getAvailabilityColor";
import { CloudVideoAssetInfo } from "./CloudVideoDetailsInfo";

interface NonMatchingVideo {
    assetId: string;
    subtitle: LanguageReference;
    aspectRatio: NamedProperty;
    resolution: OrderResolutionDimensions;
    assetType?: AssetType;
}

type VideoInfoProps = {
    availability: OrderAssetAvailability;
    isTrailer?: boolean;
    requestedAspectRatio?: NamedProperty;
    requestedResolution?: OrderResolutionDimensions;
    type: OrderAssetStorageType;
    nonMatchingVideos: NonMatchingVideo[];
    testId?: string;
};

export const VideoInfo = (video: VideoInfoProps): JSX.Element => {
    const iconName = getAssetAvailabilityIconName(video.availability);
    const iconColor = getAssetAvailabilityColor(video.availability, video.type);

    const displayAvailabilityInfo = video.availability !== OrderAssetAvailability.FullMatch;

    return (
        <Stack
            horizontal={true}
            styles={{ root: { height: 20, display: "flex", alignItems: "center" } }}
            tokens={{ childrenGap: 5 }}
            data-testid={video.testId}
            data-testavailable={video.availability.toString()}
            data-testtype={video.type.toString()}
        >
            <Icon iconName={iconName} color={iconColor} />

            {displayAvailabilityInfo && video.requestedAspectRatio && (
                <CloudVideoAssetInfo
                    requestedAspectRatio={video.requestedAspectRatio}
                    requestedResolution={video.requestedResolution}
                    nonMatchingVideos={video.nonMatchingVideos}
                />
            )}
        </Stack>
    );
};
